'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _plugin = require('../../plugin');
var _plugin2 = _interopRequireDefault(_plugin);
var _constants = require('../../constants');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function buildStatusData(_ref) {
  var sender = _ref.sender,
    roomname = _ref.roomname;
  return {
    user: sender,
    roomname: roomname
  };
}
function buildTimerKey(_ref2) {
  var user = _ref2.user,
    roomname = _ref2.roomname;
  return user + '-' + roomname;
}
var TypingHandler = function (_Plugin) {
  _inherits(TypingHandler, _Plugin);
  function TypingHandler(entity) {
    var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 15000;
    _classCallCheck(this, TypingHandler);
    var _this = _possibleConstructorReturn(this, (TypingHandler.__proto__ || Object.getPrototypeOf(TypingHandler)).call(this, entity));
    _this.timers = {};
    _this.timeout = timeout;
    return _this;
  }

  /*
  *
  * API
  *
  */

  _createClass(TypingHandler, [{
    key: 'start',
    value: function start(message) {
      var _this2 = this;
      var data = buildStatusData(message);
      this._notifyStartTyping(data);
      this._scheduleTimer(data, function () {
        _this2._notifyStopTyping(data);
      });
    }
  }, {
    key: 'cancel',
    value: function cancel(message) {
      var data = buildStatusData(message);
      if (this._cancelTimer(data)) {
        this._notifyStopTyping(data);
      }
    }

    /*
    *
    * Timer Handling
    *
    */
  }, {
    key: '_cancelTimer',
    value: function _cancelTimer(data) {
      var timer = this.timers[buildTimerKey(data)];
      if (!timer) {
        return false;
      }
      clearTimeout(timer);
      delete this.timers[buildTimerKey(data)];
      return true;
    }
  }, {
    key: '_scheduleTimer',
    value: function _scheduleTimer(data, cb) {
      this._cancelTimer(data);
      this.timers[buildTimerKey(data)] = setTimeout(cb, this.timeout);
    }

    /*
    *
    * Event notification
    *
    */
  }, {
    key: '_notifyStartTyping',
    value: function _notifyStartTyping(data) {
      this.entity.emit(_constants.Events.RECEIVED_STATUS, _extends({
        type: _constants.UserStatus.START_TYPING
      }, data));
    }
  }, {
    key: '_notifyStopTyping',
    value: function _notifyStopTyping(data) {
      this.entity.emit(_constants.Events.RECEIVED_STATUS, _extends({
        type: _constants.UserStatus.STOP_TYPING
      }, data));
    }
  }]);
  return TypingHandler;
}(_plugin2.default);
TypingHandler.pluginName = 'typingHandler';
exports.default = TypingHandler;